module.exports = __webpack_public_path__ + "static/media/firstWitnessSpanishLogo.d41bbd5b.webp";